import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { ObservableHelper } from 'src/app/helpers/observable-helper';
import Company from 'src/app/model/company/company';
import { ClientCompanySelectService } from 'src/app/services/client-company-select.service';
import { SnackService } from 'src/app/services/snack.service';
import { CreateBaseProjectUrlParamsService } from '../../services/create-base-project-url-params.service';

@Component({
  selector: 'client-company-picker',
  templateUrl: './client-company-picker.component.html',
  styleUrls: ['./client-company-picker.component.scss'],
})
export class ClientCompanyPickerComponent implements OnInit {
  @Output()
  public companyIsSelected = new EventEmitter();

  loading = true;

  companyOptions: Company[];
  selectedCompany: Company;

  constructor(
    private clientCompanySelectService: ClientCompanySelectService,
    private snackService: SnackService,
    private createBaseProjectUrlParamsService: CreateBaseProjectUrlParamsService
  ) {}

  ngOnInit(): void {
    ObservableHelper.untilFirstNonNull(
      this.clientCompanySelectService.getSelectableCompaniesSubscribable()
    )
      .toPromise()
      .then((companies: Company[]) => {
        this.companyOptions = companies;
        if (!CollectionHelper.isPopulated(this.companyOptions)) {
          this.snackService.showError('Geen bedrijven beschikbaar');
        } else {
          if (this.companyOptions.length === 1) {
            this.selectedCompany = this.companyOptions[0];
            this.companySelected(this.companyOptions[0]);
          } else {
            this.selectCompanyFromParams();
          }
        }
      })
      .catch((err) => {
        if (err instanceof Error) {
          this.snackService.showError(err.message);
        } else {
          this.snackService.showError(err);
        }
      })
      .finally(() => (this.loading = false));
  }

  companySelected(company: Company): void {
    this.companyIsSelected.emit(company);
  }

  private selectCompanyFromParams() {
    const params =
      this.createBaseProjectUrlParamsService.getCreateBaseProjectUrlParams();
    if (!params.company) return;

    const company = this.companyOptions.find(
      (company) => company.regularName === params.company
    );
    if (!company) return;

    this.selectedCompany = company;
    this.companySelected(this.selectedCompany);
  }
}
